module.exports = __webpack_public_path__ + "static/media/theme-logo.cea86081.svg";